import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBrush: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPaintBrush"><Path d="M20 12.5C20 13.8807 18.8807 15 17.5 15H14.5L14.8008 19.5068C14.9087 21.1267 13.6235 22.5 12 22.5C10.3765 22.5 9.09135 21.1267 9.19922 19.5068L9.5 15H6.5C5.11929 15 4 13.8807 4 12.5V12H20V12.5Z" fill="currentColor"/><Path d="M8.25 2C8.40738 2 8.55596 2.07429 8.65039 2.2002L10 4L11.3496 2.2002C11.444 2.07429 11.5926 2 11.75 2H18.5C19.3284 2 20 2.67157 20 3.5V11H4V3.5C4 2.67157 4.67157 2 5.5 2H8.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaintBrush;
